import { useContext } from "react";
import { MainContext } from "../context/main";

export default function useMain() {
  const context = useContext(MainContext);
  if (!context)
    throw new Error("useMainContext context must be use inside AuthProvider");

  const appName =
    context?.systemConfig?.preferences?.webConfig?.title ?? "Vallaris";

  return {
    appName,
    config: context.systemConfig,
    dispatchTheme: context.dispatchTheme,
    systemConfig: context.systemConfig,
    theme: context.theme,
    userInfo: context.userInfo,
  };
}
